import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
   apiKey: 'AIzaSyAHOjDxdoAtciLWfPhWMjsvZ-qraDv8Kbg',
   authDomain: 'oktutor-9a6f0.firebaseapp.com',
   databaseURL: 'https://oktutor-9a6f0.firebaseio.com',
   projectId: 'oktutor-9a6f0',
   storageBucket: 'oktutor-9a6f0.appspot.com',
   messagingSenderId: '429939502930',
   appId: '1:429939502930:web:b045882dc8f2d9958ad48b',
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const database = getDatabase(app);
